export const unknownChipTitle = 'Unknown';
export const getAggregationItemTitle = (aggregationItemId, aggregationName, mediaResult) => {
  if (mediaResult && mediaResult.aggregations && mediaResult.aggregations[aggregationName].length) {
    const aggregation = mediaResult.aggregations[aggregationName].find(item => item.id === aggregationItemId);
    return aggregation ? aggregation.title : unknownChipTitle;
  }
  return unknownChipTitle;
};
export const getAggregationItemsTitle = (aggregatinItemIds, aggregationName, mediaResult) => aggregatinItemIds.map(itemId => getAggregationItemTitle(itemId, aggregationName, mediaResult)).join(', ');